/* ─── Solo with image: full-width row, image on left ───────────────────── */
.soloWithImage {
  flex: 0 0 100%;
}

/* ─── Solo without image: up to 3 per row; lone cards grow to fill the row (flat/wide) ─── */
.soloNoImage {
  display: flex;
  /* flex-grow:1 lets a lone card expand to fill leftover row space;
     cards in a full row of 2 or 3 share equally (no leftover). */
  flex: 1 0 calc((100% - 40px) / 3);
  min-height: 160px;
  /* enables @container queries inside LeaderStory */
  container-type: inline-size;
}

@media (max-width: 899px) {
  .soloNoImage {
    flex: 1 0 calc((100% - 20px) / 2);
  }
}

@media (max-width: 599px) {
  .soloNoImage {
    flex: 1 0 100%;
  }
}

.soloNoImage > * {
  flex: 1;
  min-width: 0;
}

/* ─── Pair (1 secondary — 2 equal cards) ───────────────────────────────── */
.pair {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
  flex: 0 0 100%;
}

@media (max-width: 599px) {
  .pair {
    grid-template-columns: 1fr;
  }
}

/* ─── Shared base for 3-card and 4-card layouts ─────────────────────────── */
.grouping {
  display: grid;
  gap: 16px;
  align-items: stretch;
  flex: 0 0 100%;
}

/* ─── 3-card layout (1 leader + 2 secondaries stacked right) ────────────── */
/* ≥ 700px: leader 60% left, two medium cards stacked right, equal overall height */
@media (min-width: 700px) {
  .groupThree {
    grid-template-columns: 3fr 2fr;
    grid-template-rows: 1fr;
  }

  .groupThree .leader {
    grid-column: 1;
    grid-row: 1;
    display: flex;
  }

  .groupThree .leader > * {
    flex: 1;
  }

  .groupThree .secondaryStack {
    grid-column: 2;
    grid-row: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .groupThree .secondaryStack > * {
    flex: 1;
  }
}

/* < 700px: stacked */
@media (max-width: 699px) {
  .groupThree {
    grid-template-columns: 1fr;
  }

  .groupThree .secondaryStack {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}

/* ─── 4-card layout (1 leader + 3 secondaries) ──────────────────────────── */
/* ≥ 900px: leader 60% left, three compact cards stacked right */
@media (min-width: 900px) {
  .groupFour {
    grid-template-columns: 3fr 2fr;
    grid-template-rows: 1fr;
  }

  .groupFour .leader {
    grid-column: 1;
    grid-row: 1;
    display: flex;
  }

  .groupFour .leader > * {
    flex: 1;
  }

  .groupFour .secondaryStack {
    grid-column: 2;
    grid-row: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .groupFour .secondaryStack > * {
    flex: 1;
  }
}

/* 600–899px: 2×2 grid — leader top-left, secondaries fill remaining cells */
@media (min-width: 600px) and (max-width: 899px) {
  .groupFour {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .groupFour .leader {
    grid-column: 1;
    grid-row: 1;
    display: flex;
  }

  .groupFour .leader > * {
    flex: 1;
  }

  .groupFour .secondaryStack {
    /* Spread across remaining cells: top-right + bottom row */
    grid-column: 1 / -1;  /* full row below leader */
    grid-row: 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  /* Override: first secondary sits top-right alongside the leader */
  .groupFour .secondaryStack {
    grid-column: 2;
    grid-row: 1 / span 2;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .groupFour .secondaryStack > * {
    flex: 1;
  }
}

/* < 600px: all stacked */
@media (max-width: 599px) {
  .groupFour {
    grid-template-columns: 1fr;
  }

  .groupFour .secondaryStack {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}
